var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"trigger",staticClass:"scroll-top-container",class:_vm.containerClasses},[_c('div',{staticClass:"scroll-top-inner",style:({'top': _vm.threshold + 'px'})},[_vm._t("default")],2)])}
var staticRenderFns = []
module.exports = { render: render, staticRenderFns: staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d5865e10","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/Components/Elements/ScrollTop.vue
// module id = hxEu
// module chunks = 0